<template>
  <div>
    <!-- <header>
      <p>个人信息</p>
      {{ userInfo }}
    </header> -->
    <div
      style="height: calc(100vh - 88px); background-color: #fff"
      class="personal"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="first" disabled>
          <basic
            ref="basic"
            @basicList="basicList"
            :firstList="dataList.first"
          ></basic>
        </el-tab-pane>
        <el-tab-pane label="所获荣誉" name="second" disabled>
          <honor
            ref="honor"
            @honor="honor"
            :secondList="dataList.second"
          ></honor>
        </el-tab-pane>
        <el-tab-pane label="宣传报道" name="third" disabled>
          <propaganda
            ref="propaganda"
            @propaganda="propaganda"
            :thirdList="dataList.third"
            :twoDate="twoDate"
            :oneDate="oneDate"
            :msg="msg"
          ></propaganda>
        </el-tab-pane>
      </el-tabs>

      <div
        class="sub"
        style="display: flex"
        v-if="$route.path == '/taggingManage/personal-center'"
      >
        <!-- <el-button type="text" style="color: #000"
          >{{ title }}
          <i
            class="el-icon-warning-outline"
            style="color: red"
            @click="notPush"
            v-points="2000"
            v-if="title == '不发布' || title == '驳回'"
          ></i>
        </el-button> -->
        <!-- <div v-if="$route.path == '/taggingManage/personal-center'">
          <el-button type="warning">保存草稿</el-button>
          <el-button type="primary" @click="sub">提交审核</el-button>
        </div>
        <div v-if="$route.path == '/taggingManage/look-advanced'">
          <el-button type="primary">审核通过</el-button>
          <el-button type="primary" @click="sub">送审</el-button>
          <el-button type="primary" @click="reject" v-points="1000"
            >驳回</el-button
          >
          <el-button type="primary" @click="pass" v-points="1000"
            >通过</el-button
          >
          <el-button type="primary" @click="sub">撤回</el-button>
          <el-button type="primary" @click="sub">发布</el-button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import basic from "./components/basic.vue";
import honor from "./components/honor.vue";
import propaganda from "./components/propaganda.vue";
import { mapGetters } from "vuex";
import { getUserinfo } from "@/api/open";
export default {
  components: {
    basic,
    honor,
    propaganda,
  },
  data() {
    return {
      activeName: "first",
      //测试数据
      dataList: {
        first: {
          name: "",
          sex: "1",
        },
      },
      title: "",
      msg: "", //驳回原因
      reason: "", //BUFB YUANY
      oneDate: {}, //基本信息数据（传到宣传报道中进行统一操作）
      twoDate: {}, //所获荣誉数据  （传到宣传报道中进行统一操作）
    };
  },
  computed: { ...mapGetters(["userInfo"]) },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    sub() {
      // this.$refs.basic.subClick();
      // this.$refs.honor.subClick();
      // this.$refs.propaganda.subClick();
    },
    notPush() {
      this.$alert(this.reason, {
        confirmButtonText: "确定",
        callback: (action) => {
          this.$message.success("关闭");
        },
      });
    },
    //基本信息数据接收
    basicList(val) {
      console.log(val);
      this.oneDate = val;
      this.activeName = "second";
    },
    honor(val) {
      this.twoDate = val;
      if (val == "top") {
        this.activeName = "first";
      } else {
        this.activeName = "third";
      }
    },
    propaganda(val) {
      // console.log(val);

      this.activeName = "first";
      if (val == "top") {
        this.activeName = "second";
      } else {
        this.activeName = "third";
        this.getUser();
      }
    },
    async getUser() {
      // console.log(this.$route.query.id);
      let uid = this.$route.query.id;
      if (this.$route.query.id) {
        uid = this.$route.query.id;
      } else {
        uid = this.userInfo.id;
      }
      let parmas = {
        id: uid,
      };
      await getUserinfo(parmas).then((res) => {
        // console.log(res.data.current.state);
        console.log(res.data.current);
        this.$store.dispatch("GetUserInfo", res.data.current);
        localStorage.setItem('jobImg',res.data.current.job_photo)
        // console.log(res.data.former);
        if (res.data.current != null) {
          // console.log(res.data.current);
          if (res.data.current.state == 1) {
            this.title = "待审核";
          } else if (res.data.current.state == 1) {
            this.title = "待审核";
          } else if (res.data.current.state == 2) {
            this.title = "通过";
          } else if (res.data.current.state == 4) {
            this.title = "驳回";
          } else if (res.data.current.state == 5) {
            this.title = "发布";
          } else if (res.data.current.state == 6) {
            this.title = "不发布";
          }
          // console.log(res.data)
          this.msg = res.data.current.reason;
          // console.log(this.reason)
          this.$refs.propaganda.isFOU(
            res.data.current.jcy2,
            res.data.current.jcy3
          );
          this.$refs.basic.getCurrentList(res.data.current);
          this.$refs.honor.getCurrentList(res.data.current.honor);
          this.$refs.propaganda.getCurrentList(res.data.current.publicity);
          this.$refs.propaganda.reason = res.data.current.reason;
          this.$refs.propaganda.shifoutijiao =
            res.data.current.state > 0 ? false : true;
          this.$refs.propaganda.shifoubutongguo = res.data.current.state;
          this.$refs.propaganda.currentList = res.data.current;
        }
        //以上用作回显
        //以下用作判断是否修改
        if (res.data.former != null) {
          this.$refs.basic.getFormerListList(res.data.former);
          this.$refs.honor.getFormerListList(res.data.former.honor);
          this.$refs.propaganda.getFormerListList(res.data.former.publicity);
        }
      });
    },
  },
  watch: {},
  mounted() {
    if (this.$route.meta.keepAlive) {
      this.activeName = "first";
      this.getUser();
    }
  },
  created() {
    // console.log(this.userInfo)
  },
  activated() {
    if (!this.$route.meta.keepAlive) {
      this.activeName = "first";
      this.getUser();
    }
    // console.log(this.userInfo);
  },
};
</script>
<style lang="scss" scoped>
.personal {
  padding: 5px 25px;
  position: relative;
  .sub {
    position: absolute;
    right: 25px;
    top: 8px;
  }
}
/deep/.el-button {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  padding: 0.7rem 0.8rem;
  border: none;
}
/deep/.el-tabs__nav-wrap::after {
  // background-color: transparent;
  width: 100%;
}
/deep/.el-tabs__item {
  height: 3rem;
  line-height: 3rem;
}
/deep/.el-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/deep/.el-tabs__content {
  flex: 1;
}
/deep/.el-tab-pane {
  height: 100%;
}
/deep/.el-tabs__item:hover {
  color: #c0c4cc;
}
</style>
